const DEFAULT_REQUIRED_FIELDS = ['name', 'assignees', 'status', 'criticality', 'actions'];

module.exports = { DEFAULT_REQUIRED_FIELDS };
